import React, {Component} from 'react'
import {Select} from 'antd'
import {compose} from 'recompose'
import {get} from 'lodash'
import withSelectFetch from '../withSelectFetch'
import withSpinning from '../../HOC/withSpinning'
import withSort from '../../HOC/withSort'

const Option = Select.Option

class StatutoryType extends Component {
  render() {
    const {value, onChange, placeholder} = this.props
    const list =
      get(
        this.props.data.find(
          d => d._id === `members/${this.props.companyKey}`,
        ) || {},
        'list',
      ) || []

    const Sorted = compose(withSort)(props => (
      <Select
        style={{minWidth: '130px'}}
        value={value}
        showSearch
        onChange={onChange}
        placeholder={placeholder || 'Select a Type'}
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }>
        {props.data.map(c => <Option value={c.key}>{c.value}</Option>)}
      </Select>
    ))
    return <Sorted {...this.props} data={list} />
  }
}

const StatutoryTypeSelect = compose(
  withSelectFetch({dropdown: 'employee', name: 'statutory', cache: true}),
  withSpinning,
)(StatutoryType)

export default StatutoryTypeSelect
